exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mainContent[data-v-1c8dbd9a]{padding:0 60px}.topSubMenu[data-v-1c8dbd9a]{padding:0 60px;margin:10px 0 5px}.selectedMenu li a[data-v-1c8dbd9a]{color:#510087;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c8dbd9a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/informes/Guides.vue
// module id = 985
// module chunks = 2